module.exports = __webpack_public_path__ + "static/media/Message.cc51ac7c.svg";